import "./ardmore.css";

import React from "react";
import { Link } from "react-router-dom";

import { ARDMORE, ARDMORE_CATEGORY, ROUTES } from "../../data/content";
import { getArtworksBy } from "../../data/gallery";
import ArtworkGrid from "../general/ArtworkGrid";
import PageMeta from "../general/PageMeta";
import PageTitle from "../general/PageTitle";
import YouTube from "../general/YouTube";

//Exhibition catalogue: large page with thumbnails underneath (the Wix slideshow)
const Catalogue = () => {
  const [index, setIndex] = React.useState(0);
  const count = ARDMORE.CATALOGUE.length;
  const thumbsRef = React.useRef(null);

  const show = (i) => {
    const next = (i + count) % count;
    setIndex(next);
    const thumb = thumbsRef.current.children[next];
    if (thumb) {
      thumb.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    }
  };

  const onKeyDown = (e) => {
    if (e.key === "ArrowLeft") {
      show(index - 1);
    }
    else if (e.key === "ArrowRight") {
      show(index + 1);
    }
  };

  return (
    <div
      className={"catalogue"}
      role={"region"}
      aria-roledescription={"carousel"}
      aria-label={ARDMORE.CATALOGUE_TITLE}
      onKeyDown={onKeyDown}
    >
      <div className={"catalogue-stage"}>
        <button
          type={"button"}
          className={"catalogue-arrow is-back"}
          onClick={() => show(index - 1)}
          aria-label={"Previous page"}
        >
          <svg
            viewBox={"0 0 12 22"}
            aria-hidden={"true"}
          >
            <path d={"M11 1L1 11l10 10"} />
          </svg>
        </button>
        <img
          key={index}
          src={ARDMORE.CATALOGUE[index]}
          alt={`${ARDMORE.CATALOGUE_TITLE} - catalogue page ${index + 1} of ${count}`}
          width={1400}
          height={1400}
        />
        <button
          type={"button"}
          className={"catalogue-arrow is-next"}
          onClick={() => show(index + 1)}
          aria-label={"Next page"}
        >
          <svg
            viewBox={"0 0 12 22"}
            aria-hidden={"true"}
          >
            <path d={"M1 1l10 10L1 21"} />
          </svg>
        </button>
      </div>
      <p
        className={"catalogue-count"}
        aria-live={"polite"}
      >
        {index + 1} / {count}
      </p>
      <ul
        ref={thumbsRef}
        className={"catalogue-thumbs"}
      >
        {ARDMORE.CATALOGUE.map((src, i) => (
          <li key={src}>
            <button
              type={"button"}
              className={i === index ? "is-active" : ""}
              onClick={() => show(i)}
              aria-label={`Show catalogue page ${i + 1}`}
              aria-current={i === index ? "true" : undefined}
            >
              <img
                src={src}
                alt={""}
                loading={"lazy"}
                width={100}
                height={100}
              />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

const Ardmore = () => {
  const artworks = React.useMemo(() => getArtworksBy(ARDMORE_CATEGORY.slug), []);

  return (
    <div className={"page"}>
      <PageMeta
        title={"Ardmore Ceramics"}
        description={"Ardmore Ceramics at The Charles Greig Gallery - collectable ceramic sculpture from the renowned KwaZulu-Natal studio founded by Fée Halsted in 1985."}
      />
      <PageTitle>{ARDMORE.PAGE_TITLE}</PageTitle>

      <div className={"container"}>
        <section className={"title-box ardmore-logo-box"}>
          <h2 className={"ardmore-logo"}>
            <img
              src={ARDMORE.LOGO}
              alt={"Ardmore"}
              width={600}
              height={316}
            />
          </h2>
        </section>

        <section className={"ardmore-intro"}>
          <div>
            {ARDMORE.TEXT.map((text) => (
              <p
                key={text}
                className={"body-text"}
              >
                {text}
              </p>
            ))}
          </div>
          <img
            className={"ardmore-photo"}
            src={ARDMORE.PHOTO.src}
            alt={ARDMORE.PHOTO.alt}
            width={624}
            height={848}
          />
        </section>

        <section
          className={"ardmore-artworks"}
          aria-labelledby={"artworks-title"}
        >
          <h2
            id={"artworks-title"}
            className={"section-title"}
          >
            {ARDMORE.ARTWORKS_TITLE}
          </h2>
          <Catalogue />

          <hr className={"ardmore-rule"} />

          <ArtworkGrid
            artworks={artworks}
            pageSize={12}
          />
          <p className={"artist-shop-link"}>
            <Link to={ROUTES.ALL_ARTWORKS}>Browse all artworks</Link>
          </p>
        </section>

        <section className={"ardmore-video"}>
          <YouTube
            id={ARDMORE.YOUTUBE_ID}
            title={"Ardmore Ceramics"}
          />
        </section>
      </div>
    </div>
  );
};

export default Ardmore;
